<payment-footer
  [translations]="translations$ | async"
  [currentStep]="currentStep$ | async"
  [subscriberAgreementUrl]="subscriberAgreementUrl$ | async"
  [sessionExitUrl]="(sessionSummary$ | async)?.onSessionExitUrl"
  [sessionCompleteUrl]="(sessionSummary$ | async)?.onSessionCompleteUrl"
  [paymentSucceeded]="paymentSucceeded$ | async"
  [hasPayOtherAmountThrownAnError]="hasPayOtherAmountThrownAnError$ | async"
  [showContactInformation]="showContactInformation$ | async"
  [contactInformation]="contactInformation$ | async"
  [isAlternativePaymentMethodAvailable]="
    isAlternativePaymentMethodAvailable$ | async
  "
  (sessionExitClicked)="onSessionExitClicked()"
  (proceedToPaymentClicked)="onProceedToPaymentClicked()"
  (backFromSelectPaymentTypeClicked)="onBackFromSelectPaymentTypeClicked()"
  (backFromSelectPaymentMethodClicked)="onBackFromSelectPaymentMethodClicked()"
  (backFromConfirmPaymentClicked)="onBackFromConfirmPaymentClicked()"
  (reviewPaymentClicked)="onReviewPaymentClicked()"
  (backFromReviewPaymentClicked)="onBackFromReviewPaymentClicked()"
  (authorizePaymentClicked)="onAuthorizePaymentClicked()"
  (returnToAppClicked)="onReturnToAppClicked()"
>
</payment-footer>
